import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useLoyaltyDashboard } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Users, Star, Gift, Trophy } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
export function LoyaltyDashboardPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const {
    customers,
    loading
  } = useLoyaltyDashboard(restaurant.restaurant_id);
  const totalCustomers = customers.length;
  const totalPoints = customers.reduce((sum, c) => sum + (c.current_points || 0), 0);
  const totalRewardsAvailable = customers.reduce((sum, c) => sum + (c.available_rewards_count || 0), 0);
  const totalRewardsRedeemed = customers.reduce((sum, c) => sum + (c.redeemed_rewards_count || 0), 0);
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-3159">
      <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-3160">
        <div data-id="element-3161">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-3162">
            Programa de Lealtad
          </h1>
          <p className="text-gray-500" data-id="element-3163">
            Gestiona tus clientes frecuentes y beneficios
          </p>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3164">
          <Card className="p-6" data-id="element-3165">
            <div className="flex items-center gap-4" data-id="element-3166">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3167">
                <Users className="w-6 h-6 text-blue-600" data-id="element-3168" />
              </div>
              <div data-id="element-3169">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3170">
                  Clientes Leales
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3171">
                  {totalCustomers}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3172">
            <div className="flex items-center gap-4" data-id="element-3173">
              <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3174">
                <Star className="w-6 h-6 text-yellow-600" data-id="element-3175" />
              </div>
              <div data-id="element-3176">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3177">
                  Puntos Emitidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3178">
                  {totalPoints}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3179">
            <div className="flex items-center gap-4" data-id="element-3180">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3181">
                <Gift className="w-6 h-6 text-green-600" data-id="element-3182" />
              </div>
              <div data-id="element-3183">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3184">
                  Beneficios Disponibles
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3185">
                  {totalRewardsAvailable}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3186">
            <div className="flex items-center gap-4" data-id="element-3187">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3188">
                <Trophy className="w-6 h-6 text-purple-600" data-id="element-3189" />
              </div>
              <div data-id="element-3190">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3191">
                  Beneficios Redimidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3192">
                  {totalRewardsRedeemed}
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Customer Table */}
        <Card className="overflow-hidden" data-id="element-3193">
          <div className="p-6 border-b border-gray-200" data-id="element-3194">
            <h2 className="font-bold text-gray-900" data-id="element-3195">Directorio de Clientes</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-3196">
            <table className="w-full text-left text-sm" data-id="element-3197">
              <thead className="bg-gray-50 text-gray-500" data-id="element-3198">
                <tr data-id="element-3199">
                  <th className="px-6 py-4 font-medium" data-id="element-3200">Cliente</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3201">Teléfono</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3202">Visitas</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3203">
                    Total Gastado
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3204">
                    Ticket Promedio
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3205">Puntos</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3206">Nivel</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-3207">
                {loading ? <tr data-id="element-3208">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3209">
                      Cargando clientes...
                    </td>
                  </tr> : customers.length === 0 ? <tr data-id="element-3210">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3211">
                      No hay clientes registrados aún.
                    </td>
                  </tr> : customers.map(customer => <tr key={customer.customer_id} className="hover:bg-gray-50" data-id="element-3212">
                      <td className="px-6 py-4 font-medium text-gray-900" data-id="element-3213">
                        {customer.name || 'Sin nombre'}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-3214">
                        {customer.phone}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3215">
                        {customer.total_orders}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3216">
                        {formatCurrency(customer.total_spent, restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-500" data-id="element-3217">
                        {formatCurrency(customer.total_spent / Math.max(1, customer.total_orders), restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-brand-charcoal" data-id="element-3218">
                        {customer.current_points}
                      </td>
                      <td className="px-6 py-4" data-id="element-3219">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-3220">
                          {customer.current_level || 'Inicial'}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>;
}